var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0C13.664 0 0 13.664 0 30.5C0 47.336 13.664 61 30.5 61C47.336 61 61 47.336 61 30.5C61 13.664 47.336 0 30.5 0ZM30.5 12.2C36.3865 12.2 41.175 16.9885 41.175 22.875C41.175 28.7615 36.3865 33.55 30.5 33.55C24.6135 33.55 19.825 28.7615 19.825 22.875C19.825 16.9885 24.6135 12.2 30.5 12.2ZM30.5 54.9C24.3085 54.9 16.9885 52.399 11.773 46.116C17.1154 41.9244 23.7095 39.6464 30.5 39.6464C37.2905 39.6464 43.8846 41.9244 49.227 46.116C44.0115 52.399 36.6915 54.9 30.5 54.9Z",
    fill: "#DEE3E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcons);
export default __webpack_public_path__ + "static/media/UserIcons.fe17f0967da96452431afdc92ab1084b.svg";
export { ForwardRef as ReactComponent };